import React from 'react'
import CatalogSearch from './CatalogSearch';
import {ReactComponent as FilterSvg} from '../../../assets/img/filtro.svg'

const CatalogSimpleHeader = (props) => {
  const {
    onProductTextSearch,
    searching,
    onSearchOpen,
    filtering,
    onFilterShow,
    onFilterHide
  } = props

  return(
    <div className="flex justify-end mx-2 items-center py-5">
      <div className="flex g-input__container">
        <CatalogSearch
          searching={searching}
          onProductTextSearch={onProductTextSearch}
          onSearchOpen={onSearchOpen}
        />
        <span className="catalog__line"/>
        <button className="outline-reset" onClick={filtering? onFilterHide: onFilterShow}>
          <FilterSvg className={filtering ? "primary-fill" : "dead-grey-fill"}/>
        </button>
      </div>
    </div>
  )
}
export default CatalogSimpleHeader
